import styled from 'styled-components/macro';
import PropTypes from 'prop-types';

export const Block = styled.div`
  background: ${({ background }) => background};
  padding: ${({ padding }) => padding};
  padding-top: ${({ paddingTop }) => paddingTop};
  padding-right: ${({ paddingRight }) => paddingRight};
  padding-bottom: ${({ paddingBottom }) => paddingBottom};
  padding-left: ${({ paddingLeft }) => paddingLeft};
  margin: ${({ margin }) => margin};
  margin-top: ${({ marginTop }) => marginTop};
  margin-right: ${({ marginRight }) => marginRight};
  margin-bottom: ${({ marginBottom }) => marginBottom};
  margin-left: ${({ marginLeft }) => marginLeft};
  min-width: min-content;
  align-self: ${({ alignSelf }) => alignSelf};
  align-items: ${({ align }) => align};
  justify-content: ${({ justify }) => justify};
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
  overflow: ${({ overflow }) => overflow};
  overflow-x: ${({ overflowX }) => overflowX};
  overflow-y: ${({ overflowY }) => overflowY};
  display: ${({ inline }) => (inline ? 'inline-block' : 'block')};
  max-width: ${({ maxWidth }) => maxWidth};
`;

Block.propTypes = {
  background: PropTypes.string,
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  paddingTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  paddingRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  paddingBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  paddingLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  margin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  marginTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  marginRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  marginBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  marginLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  visibility: PropTypes.string,
  alignSelf: PropTypes.string,
  align: PropTypes.string,
  justify: PropTypes.string,
  overflow: PropTypes.string,
  inline: PropTypes.bool,
  maxWidth: PropTypes.string,
};

Block.defaultProps = {
  background: 'none',
  margin: '0',
};

export const TextElement = styled(Block)`
  align-self: ${({ align }) => align};
  font-size: ${({ size }) => size};
  color: ${({ color }) => color};
  width: fit-content;
  text-align: ${({ justify }) => justify};
  font-family: ${({ font }) => font};
  text-decoration: ${({ textDecoration }) => textDecoration};
`;

TextElement.propTypes = {
  align: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  justify: PropTypes.string,
  textDecoration: PropTypes.string,
};

TextElement.defaultProps = {
  align: null,
  size: null,
  color: null,
  justify: null,
  textDecoration: null,
};
